import Dropdown from 'components/Form/Dropdown';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiErrorAxios} from 'utils/request-axios/utils';

import {dataTypesToOptions} from '../helpers';
import {useCreateExtendedDataField} from './services';
import {BackendData, FormValues} from './types';

const Create: FC = () => {
    const {data} = useBackend<BackendData>();
    const methods = useForm<FormValues>({
        defaultValues: {dataType: '', key: '', label: ''},
    });

    const createApi = useCreateExtendedDataField(data.objectType);
    const handleSubmit = (values: FormValues) => {
        createApi
            .mutateAsync(values)
            .then(() => {
                setUrl(window.Urls.extendeddatafields_list_view());
            })
            .catch(onApiErrorAxios(methods));
    };
    return (
        <div>
            <NavigationTabs.DocumentSettings selection="extendedDataFields" />
            <SectionHeader
                title={
                    data.objectType === 'document'
                        ? t`Create Document Extended Data Field`
                        : t`Create Line Item Extended Data Field`
                }
            />
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <SideBySide className="mt-4 max-w-lg">
                        <InputText
                            label={t`Display Name`}
                            name="label"
                            required={true}
                        />
                        <InputText label={t`Key`} name="key" required={true} />
                        <Dropdown
                            label={t`Data Type`}
                            name="dataType"
                            options={dataTypesToOptions(data.dataTypes)}
                            required={true}
                            type="select"
                        />
                        <FormResult />
                        <FormActions>
                            <SubmitButton
                                disabled={
                                    !methods.formState.isValid ||
                                    createApi.isPending
                                }
                            >{t`Save`}</SubmitButton>
                        </FormActions>
                    </SideBySide>
                </form>
            </FormProvider>
        </div>
    );
};

export default Create;
